import { useState, useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'

const useRedrawId = () => {
  const [redrawId, setRedrawId] = useState(uuidv4())

  const updateRedrawId = useCallback(() => {
    setRedrawId(uuidv4())
  }, [])

  return { redrawId, updateRedrawId }
}

export default useRedrawId
